import {
  inject,
  Injectable,
} from '@angular/core';
import { exhaustMap, tap } from 'rxjs/operators';
import { ApConfirmModalService, mapToModalSuccessValue } from 'webcommon/core-ui';
import {
  BrowserService,
} from 'webcommon/legacy-common';
import {
  ApBaseClass,
  CrossWindow, SingleSub,
} from 'webcommon/shared';

// idk what to call this class, but it can't live in provider-api, because it needs to depend on core-ui,
// while containing logic related to LoginInitializationService.
@Injectable({
  providedIn: 'root',
})
export class LoginCommon extends ApBaseClass {
  private readonly crossWindow = inject(CrossWindow);
  private readonly apConfirmModalService = inject(ApConfirmModalService);
  private readonly browserService = inject(BrowserService);

  private globalEventsSingleSub = SingleSub.create(this);

  constructor(
  ) {
    super();
  }

  // Call globally to allow this to handle CrossWindow events.
  // technically, this could be opt-in per app.
  listenGlobalEvents(): void {
    this.globalEventsSingleSub.start(this.crossWindow.on('aprima-login-sync').pipe(
      exhaustMap(() => {
        // Open a modal to notify the user that the login session changed
        // and give an option to reload the page.
        // Previously, the user could cancel, but that can end up in a weird state where the user sees info for a different user
        // than what the token is connected to, so any server actions could cause problems.
        // So... I changed the other option to close the tab instead.
        //
        // Actually, closing the tab is not possible ----
        // I was previously trying to close the tab here,
        // but it's not possible to close the tab with window.close(), unless the tab was opened as a popup from another tab.
        // So, we either have to reload, redirect, or the user manually close the tab with the X.
        // Also, we could try to avoid this by separating the tabs to not share the same login session by not using localStorage,
        // or anything else that would be used across tabs.
        return this.apConfirmModalService.openModal$(
          '',
          'You’ve logged in with another tab. Would you like to Reload the page to update your session?',
          'CGM Aprima',
          'Reload',
          null,
          null,
          null,
          true
        ).pipe(
          mapToModalSuccessValue(),
          tap(value => {
            if (value) {
              // idk 100% if this should reload the full-page or use ui-router reload?
              this.browserService.reload();
            }
          })
        );
      }),
    ).subscribe());
  }

  stopGlobalEvents(): void {
    this.globalEventsSingleSub.stop();
  }
}
